module.exports = __webpack_public_path__ + "media/customizations/woodcreek/logo-01027244c8a3daba29c2b23287a721eb.png";